import React, { Component } from 'react';

import OptionItem from "./OptionItem";

export default class Options extends Component {

    constructor(props) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle = () => {
        this.props.handleToggle();
    };

    render() {

        const options = this.props.options;
        const debug = this.props.debug;

        return (
            <div className="options">
                <table>
                    <tbody>
                        {options.sort((a, b) => Number(a.sequence.toString().replace(',', '.')) > Number(b.sequence.toString().replace(',', '.')) ? 1 : -1)
                            .map((option, index) => (
                                (option.visible === undefined || option.visible === true) &&
                                <OptionItem
                                    extDisable={this.props.extDisable}
                                    configurationId={this.props.configurationId}
                                    key={index}
                                    option={option}
                                    debug={debug}
                                    updateConfiguration={this.props.updateConfiguration}
                                    requiredFeature={this.props.requiredFeature}
                                    handleToggle={this.handleToggle}
                                    updatePostingStatus={this.props.updatePostingStatus}
                                    handleLock={this.props.handleLock}
                                    showError={this.props.showError}
                                />
                            ))}
                    </tbody>
                </table>
            </div>
        );
    }
}